import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Modal, Table } from "antd";
import iconHeaderYourCode from "../../../../../assets/images/Event-2024/title-your-code.png";
import iconClose from "../../../../../assets/images/Event-2024/icon-btn-close-popup.png";
import iconRulesFooter from "../../../../../assets/images/Event-2024/bot-popup-rules.png";
import bg from "../../../../../assets/images/Event-2024/bg-popup-rules.png";
import moment from "moment";
import {
  curStateEventNewYear2024,
} from "../../../../../Redux/selector";
import { useDispatch, useSelector } from "react-redux";
import { getUserCodeNewYear2024 } from "../../../../../Redux/futures/event-new-year-noel/actions";
import { useTranslation } from "react-i18next";

export default function PopupComponentHistoryYourCode({
  open,
  setOpen = () => {},
  data = {},
}) {
  const { t } = useTranslation();
  const handleCancel = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const totalTableYourCode = 10;
  const { userCode } = useSelector(curStateEventNewYear2024) || {};
  useEffect(() => {
    if(open){
      const data = {
        page,
        limit: totalTableYourCode,
      };
      dispatch(getUserCodeNewYear2024(data));
    }
  }, [page, open]);

  const columns = [
    {
      title: `${t("event_new_year.no")}`,
      dataIndex: "key",
      key: "key",
      render: (index) => <div>{(page - 1) * totalTableYourCode + index + 1}</div>,
      
    },
    {
      title: `${t("event_new_year.code")}`,
      dataIndex: "code",
      key: "code",
      align: "center",
      render: (text) => <div>{text}</div>,
    },
    {
      title: `${t("event_new_year.time")}`,
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (_, record) => {
        const datePart = moment(_).format("YYYY-MM-DD");
        const timePart = moment(_).format("HH:mm:ss");
        if(!_) return(<div></div>)
        return (
          <div className="item-rank-timer">
            <span>{datePart}&nbsp;&nbsp;{timePart}</span>
          </div>
        );
      },
    },
  ];

  // const scrollToTop = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // };

  const handleTableChange = (pagination) => {
    setPage(pagination);
    // scrollToTop();
  };

  const {
    imgMain,
    imgLeft,
    imgRight,
    isFailsAll = false,
  } = data;

  return (
    <StyleModal
      centered
      open={open}
      onOk={handleCancel}
      onCancel={handleCancel}
      closable={false}
      getContainer={false}
    >
      <div className="position-relative">
        <img src={bg} alt="" className="bg-popup" />
        <img
          src={iconClose}
          alt=""
          className="icon-close"
          onClick={handleCancel}
        />
        <div className="header-container-popup">
          <img src={iconHeaderYourCode} alt="" className="icon-header-popup" />
        </div>

        <div className="body-popup">
          <div className="main-body">
            <div className="main-content">
              <div className="title_his">
                <i>{t("event_new_year.congratulations")}</i>
                <i>{t("event_new_year.these_are_the_codes_you_have_collected")}</i>
              </div>
              <Table
                dataSource={userCode?.codes || []}
                columns={columns}
                pagination={
                  userCode?.total > totalTableYourCode
                    ? {
                        current: page,
                        pageSize: totalTableYourCode,
                        total: userCode?.total || 0,
                        onChange: handleTableChange,
                        showSizeChanger: false,
                        showLessItems: true,
                      }
                    : false
                }
                className={`custom-table custom-table-rules`}
              />
            </div>
          </div>
          <div className="main-footer">
            <img src={iconRulesFooter} alt="" className="icon-rule-footer" />
          </div>
        </div>
      </div>
    </StyleModal>
  );
}

const StyleModal = styled(Modal)`
  .header-container-popup img {
      max-height: 140px;
  }
.custom-table-rules{
  .ant-table{
    background: radial-gradient(64.68% 64.68% at 50% 50%, #F4E7CD 0%, #E3CDA4 100%) !important;
    padding: 0 20px;
    border-radius: 16px;
  }
  th{
    background: unset !important;
  }
  th:before{
    width: 0 !important;
  }
  tr:last-child td{
    border-bottom: unset;
  }
  td:first-child{
    padding: 10px 0 0 16px !important;
  }
  td{
    padding: 10px 0 !important;
  }

  .ant-table-cell-row-hover {
      background-color: #d4bb8b !important;
  }
  .ant-pagination {
    justify-content: center;
    position: relative;
    z-index: 1;

    .ant-pagination-prev,
    .ant-pagination-next {
      height: 40px;
      width: 40px;
    }

    .ant-pagination-item {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin: 0;

      a {
        color: #44403C;
        font-weight: 600;
      }
    }

    .ant-pagination-item-active {
      border: none;
      background-color: #E2CDA3;
    }

    .ant-pagination-jump-next-custom-icon,
    .ant-pagination-jump-prev-custom-icon {
      line-height: 45px;
    }

    .ant-pagination-item-ellipsis {
      font-size: 12px;
      color: #44403C;
      letter-spacing: 0.2px;
    }
  }
  .ant-table-placeholder{
    background: unset !important;
    &:hover{
      background: unset !important;
      td{
        background: unset !important;
      }
    }
  }
}
.title_his{
  color: #292524;
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
}
.title_his i{
  line-height: 20px;
  font-size: 16px;
  font-weight: 500;
}
  .error-number {
    display: flex;
    width: 90%;
    margin: 0 auto;
    gap: 20px;
  }

  .icon-error-full {
    width: 255px !important;
  }

  .content-footer {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    width: 90%;
    margin: 0 auto;
    padding-bottom: 15px;
  }

  .icon-main-popup img {
    position: absolute;
    bottom: 0;
    z-index: 10;
    pointer-events: none;
  }

  .icon-main-popup {
    .icon-ng,
    .icon-th {
      bottom: 140px;
    }

    .icon-ng {
      left: 0;
    }

    .icon-th {
      right: -60px;
    }
  }

  .icon-main-popup .icon-error {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
  }

  .bg-popup {
    border-radius: 30px;
    overflow: hidden;
    height: 100%;
  }

  .body-popup {
    border-radius: 30px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }

  .main-footer {
    width: 100%;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    height: 100%;
    pointer-events: none;
  }

  .icon-rule-footer {
    bottom: 0;
    left: 0;
    position: absolute;
  }

  .main-content {
    color: white;
    width: 100%;
    padding-top: 65px;
    padding-left: 40px;
    padding-right: 40px;
    font-size: 20px;
    line-height: 1.4;
    font-weight: 500;
  }

  .content-forcus {
    color: #f1e884;
  }

  .icon-close {
    position: absolute;
    right: -12px;
    z-index: 9;
    top: -12px;
    width: 42px;
    cursor: pointer;
  }

  .header-container-popup {
    position: absolute;
    top: -75px;
    left: 50%;
    transform: translateX(-50%);
    max-width: calc(100% + 40px);
    width: calc(100% + 40px);
    z-index: 2;
  }

  .content-header {
    position: absolute;
    z-index: 2;
    color: white;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
  }

  .main-body {
    position: absolute;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
  }

  .btn-close-popup-event {
    color: white;
    font-size: 20px;
    position: absolute;
    z-index: 2;
    right: 10px;
    top: 3px;
    cursor: pointer;
  }

  .position-relative {
    position: relative;
  }

  .position-absolute {
    position: absolute;
  }

  .ant-modal-content {
    background-color: inherit !important;
    box-shadow: inherit !important;
    padding: 0 !important;
  }

  .ant-modal-footer {
    display: none;
  }

  .ant-modal-body {
    text-align: center;
    display: flex;
    justify-content: center;
    padding-top: 30px;
  }

  .ant-modal-close {
    right: 40px !important;

    svg {
      color: white;
    }
  }

  @media (min-width: 992px) {
    .icon-close,
    .container-action-main {
      &:hover {
        scale: 1.05;
        transition: 0.3s ease-in-out;
      }
    }
  }

  @media (max-width: 768px) {
  }

  @media (max-width: 576px) {
    .custom-table-rules .ant-table {
      padding: 0 10px;
      .ant-table-cell div{
        font-size: 12px !important;
      }
    }

    .bg-popup{
      height: 640px !important;
    }
    .anticon{
      position: relative;
      top: -2px;
    }
    .main-content{
      padding-top: 55px !important;
    }
    .title_his{
      margin-bottom: 15px;
    }
    .custom-table-rules{
      td{
        padding-top: 6px !important;
        padding-bottom: 6px !important;
      }
      th{
        padding: 8px 16px !important;
      }
      .ant-pagination{
        margin-top: 10px !important;
        .ant-pagination-item {
          min-width: 30px;
          width: 30px;
          height: 30px;
        }
        .ant-pagination-jump-next-custom-icon{
          line-height: 35px !important;
        }
        .ant-pagination-next, .ant-pagination-prev {
            height: 30px;
            width: 30px;
        }
      }
    }

    .header-container-popup {
      width: 75% !important;
      top: -45px;
    }
    .title_his i{
      font-size: 14px;
    }
    .header-container-popup {
      max-width: calc(100% + 10px);
      width: calc(100% + 10px);
    }

    .icon-close {
      width: 36px;
      right: 5px;
    }

    .content-header {
      top: 20px;
    }

    .main-content {
      padding-top: 60px;
      padding-left: 25px;
      padding-right: 25px;
      font-size: 16px;
      line-height: 1.4;
      font-weight: 500;
    }

    .icon-ng {
      width: 120px;
    }

    .icon-main-popup .icon-ng,
    .icon-main-popup .icon-th {
      bottom: 130px;
    }

    .icon-main-popup .icon-error {
      width: 160px;
    }

    .content-footer {
      padding-bottom: 25px;
      font-size: 13px;
    }

    .icon-error-full {
      width: 180px !important;
    }
  }

  @media (max-width: 430px) {
    .content-header {
      top: 16px;
    }

    .icon-main-popup .icon-ng,
    .icon-main-popup .icon-th {
      bottom: 110px;
    }

    .icon-ng {
      width: 100px;
    }

    .icon-th {
      height: 160px;
    }
  }
`;
